import { getServiceUrls } from "../services/serviceUrls";

export const getUrls = () => {
  const SERVICE_URL = getServiceUrls();

  return {
    GET_ALL_TRIP: `${SERVICE_URL.TRIP_SERVICE}/review-trip`,
    GET_DOCUMENT: `${SERVICE_URL.TRIP_SERVICE}/documents/`,
    APPROVE_ESCORT: (tripId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-trip/${tripId}/approve-escort`,
    REJECT_ESCORT: (tripId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-trip/${tripId}/reject-escort`,
    CORRECTION_NEEDED_ESCORT: (tripId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-trip/${tripId}/request-escort-correction`,
    APPROVE_AFTER_HOURS: (tripId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-trip/${tripId}/approve-overtime`,
    REJECT_AFTER_HOURS: (tripId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-trip/${tripId}/reject-overtime`,
    APPROVE_TRIP: (tripId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-trip/${tripId}/approve`,
    CORRECTION_NEEDED_TRIP: (tripId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-trip/${tripId}/request-correction`,
    EXEMPT_TRIP: (tripId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-trip/${tripId}/exemption`,
    ADD_ESCORT_OFFICERS: (tripId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-trip/${tripId}/escort-officer`,
    ADD_AFTER_HOURS_OFFICERS: (tripId) =>
      `${SERVICE_URL.TRIP_SERVICE}/review-trip/${tripId}/overtime-officer`,
    GET_TRIP: (tripId) => `${SERVICE_URL.TRIP_SERVICE}/trips/${tripId}`,
    GET_TRIP_FEE: (tripId) => `${SERVICE_URL.TRIP_SERVICE}/trip-fee/${tripId}`,
    SEARCH_TRIP_FEE: `${SERVICE_URL.TRIP_SERVICE}/review-trip/search`,
    LIST_OF_AIRPORT: `${SERVICE_URL.FEE_SERVICE}/airport`,
    SEARCH_AIRPORT: `${SERVICE_URL.FEE_SERVICE}/airport/search`,
    GET_HISTORIC_TRIP: `${SERVICE_URL.TRIP_SERVICE}/review-trip/historic`,
    SEARCH_HISTORIC_TRIP: `${SERVICE_URL.TRIP_SERVICE}/review-trip/historic/search`,
    GET_AIRCRAFT_BY_ID: (aircraftTypeId) =>
      `${SERVICE_URL.TRIP_SERVICE}/aircraft-type/${aircraftTypeId}`,
    GET_TRIP_BY_FILTERS: `${SERVICE_URL.TRIP_SERVICE}/review-trip/filter`,
    GET_HISTORIC_TRIP_BY_FILTERS: `${SERVICE_URL.TRIP_SERVICE}/review-trip/historic-by-filters`,
    EXPORT_UPCOMING: `${SERVICE_URL.TRIP_SERVICE}/review-trip/export-upcoming`,
    EXPORT_HISTORIC_TRIPS: `${SERVICE_URL.TRIP_SERVICE}/review-trip/export-historic`,
    ADD_DEVICE_TOKEN: `${SERVICE_URL.FEE_SERVICE}/aa-profile/add-device-token`,
    REMOVE_DEVICE_TOKEN: `${SERVICE_URL.FEE_SERVICE}/aa-profile/remove-device-token`,
    USER_PROFILE: `${SERVICE_URL.FEE_SERVICE}/aa-profile/me`,
    GET_OVERTIME_LIST: `${SERVICE_URL.TRIP_SERVICE}/review-trip/overtime`,
    GET_ESCORT_LIST: `${SERVICE_URL.TRIP_SERVICE}/review-trip/escort`,
    GET_OFFICERS_BY_AIRPORT: `${SERVICE_URL.TRIP_SERVICE}/officers/airport`,
    GET_IN_APP_NOTIFICATION: `${SERVICE_URL.MESSAGING_SERVICE}/notifications`,
    MARK_NOTIFICATION_AS_READ: (notificationId) =>
      `${SERVICE_URL.MESSAGING_SERVICE}/notifications/${notificationId}/read`,
    READ_ALL_NOTIFICATIONS: `${SERVICE_URL.MESSAGING_SERVICE}/notifications/read-all`,
    DELETE_NOTIFICATION: (notificationId) =>
      `${SERVICE_URL.MESSAGING_SERVICE}/notifications/${notificationId}`,
    GET_UNREAD_NOTIFICATION_COUNT:
      `${SERVICE_URL.MESSAGING_SERVICE}/notifications/unread-count`,
    GET_UNREAD_NOTIFICATIONS: (notificationId) =>
      `${SERVICE_URL.MESSAGING_SERVICE}/notifications/${notificationId}/unread`,
    GET_UNREGISTERED_AIRCRAFT_TRIPS: `${SERVICE_URL.TRIP_SERVICE}/unregistered-adsb-trips/aircraft`,
    GET_UNREGISTERED_AIRCRAFT_TRIPS_BY_REGISTRATION: `${SERVICE_URL.TRIP_SERVICE}/unregistered-adsb-trips/by-registration-number`,
    SEARCH_UNREGISTERED_AIRCRAFT_TRIPS: `${SERVICE_URL.TRIP_SERVICE}/unregistered-adsb-trips/aircraft-search`,
    EXPORT_UNREGISTERED_AIRCRAFT_TRIPS_BY_REGISTRATION: `${SERVICE_URL.TRIP_SERVICE}/unregistered-adsb-trips/export-by-registration-number`,
    EXPORT_UNREGISTERED_AIRCRAFT_TRIPS: `${SERVICE_URL.TRIP_SERVICE}/unregistered-adsb-trips/export-aircraft`,
    GET_AIRPORT_BY_ID: (airportId) => `${SERVICE_URL.FEE_SERVICE}/airport/${airportId}`,
  };
};
